angular.module('dpw.components').component('dpwEventBanner', {
    templateUrl: 'dpw-event-banner.html',
    bindings: {
        onHeightChange: '&?'
    },
    controllerAs: 'ctrl',
    controller: ['api', 'dpwStorage', '$element', '$window', '$scope', '$timeout', '$sce', function (api, dpwStorage, $element, $window, $scope, $timeout, $sce) {
        var self = this;
        self.visible = false;
        self.htmlContent = '';
        self.logoSlot = '%bannerLogoUrl%';
        self.STORAGE_KEY = 'RCDPW-ForceEnableEventBanner';

        self.$onInit = function () {
            self.initBannerCommand();
            if (RCDPW.isAdminSite) return;

            api.call(api.myAccount.eventBanner.get(), function (data) {
                data = data.eventBanner;
                var forceEnableEventBanner = dpwStorage.getItem(self.STORAGE_KEY) === 'true';
                self.visible = data.visible || forceEnableEventBanner;

                var htmlContent = self.replaceLogoUrl(data.htmlContent, data.logo);
                self.htmlContent = $sce.trustAsHtml(htmlContent);
                self.appendStyles(data.styleContent);

                self.handleHeight();
                $window.addEventListener('resize', self.windowResizeListener);
            }, angular.noop);
        };

        self.$onDestroy = function () {
            $window.removeEventListener('resize', self.windowResizeListener);
        };

        self.handleHeight = function () {
            $timeout(function () {
                var height = self.resolveHeight();
                self.emitHeight(height);
            });
        };

        self.initBannerCommand = function () {
            RCDPW.forceEnableEventBanner = function (isBannerVisible) {
                if (isBannerVisible === undefined) {
                    isBannerVisible = true;
                }
                $scope.$apply(function () {
                    self.visible = isBannerVisible === true;
                    self.handleHeight();
                    dpwStorage.setItem(self.STORAGE_KEY, self.visible);
                });
            };
        };

        self.replaceLogoUrl = function (htmlContent, logoUrl) {
            return htmlContent.replace(new RegExp(self.logoSlot, 'g'), logoUrl);
        };

        self.appendStyles = function (styleContent) {
            var styleElement = document.createElement('style');
            styleElement.innerHTML = styleContent;
            document.head.appendChild(styleElement);
        };

        self.resolveHeight = function () {
            var element = _.first($element);
            return element.clientHeight;
        };

        self.emitHeight = function (height) {
            if (_.isFunction(self.onHeightChange)) {
                self.onHeightChange({height: height});
            }
        };

        self.windowResizeListener = _.debounce(function () {
            var height = self.resolveHeight();
            self.emitHeight(height);
        }, 100);
    }]
});
